import {useQuery} from "@tanstack/react-query"
import {thoughtPiecesEndpoints} from "../../../services/api/thought-pieces"
import { type FC} from "react"
import {
  CaseStudies,
  VideoFrame
} from "../../../components"
const MainContentTile: FC = () => {
  const {getMainContent} = thoughtPiecesEndpoints()
  const {
    data,
    isLoading,
    isRefetching,
    isError,
    isLoadingError,
  } = useQuery({
    queryKey: ["main-content"],
    queryFn: () => getMainContent(),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  })

  const loadingData = isLoading || isRefetching || !data 
  const hasError = isError || isLoadingError || data?.status == 500
  const loadedData = !loadingData ? data : undefined
  const contentField = !hasError ? loadedData?.find((x : any) => x.name === "Content Type") : undefined
  const videoField = !hasError ? loadedData?.find((x : any) => x.name === "Video URL") : undefined
  return (
    contentField?.value == "Video" && !hasError ? <VideoFrame videoURL={videoField.value}/> : <CaseStudies/>
  )
}
export default MainContentTile
